module.exports = __webpack_public_path__ + "static/img/merchant_new_2.89024aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_new_2.png
// module id = UsJs
// module chunks = 8